import UserMessage from './UserMessage';
import AssistantMessage from './AssistantMessage';

export default function ChatMessage({ message }) {
  if (message.role === 'user') return <UserMessage message={message} />;
  return <AssistantMessage message={message} />;
}
